if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Attach listeners
        this.attachVariantListeners();
        
        setTimeout(() => this.updateAvailableOptions(), 100);
      }

      attachVariantListeners() {
        // Remove old listener if exists
        if (this.materialSelect) {
          this.materialSelect.removeEventListener('change', this.boundUpdateOptions);
        }
        
        // Get material select and bind listener
        this.materialSelect = this.form.querySelector('select[name="options[Jewellery material]"]');
        this.boundUpdateOptions = this.updateAvailableOptions.bind(this);
        
        if (this.materialSelect) {
          this.materialSelect.addEventListener('change', this.boundUpdateOptions);
        }
      }

      connectedCallback() {
        // Re-attach listeners when element is re-inserted into DOM
        this.attachVariantListeners();
        this.updateAvailableOptions();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          // Check if product has pre-order tag
          const productTags = this.dataset.productTags || '';
          if (productTags.includes('pre-order')) {
            this.submitButtonText.textContent = 'Pre-order';
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      updateAvailableOptions() {
        console.log('updateAvailableOptions called');
        const variantDataElement = document.querySelector('[data-all-variants]');
        if (!variantDataElement) {
          console.log('No variant data found');
          return;
        }
        
        const variantData = JSON.parse(variantDataElement.textContent);
        const selectedMaterial = this.form.querySelector('select[name="options[Jewellery material]"]');
        
        if (!selectedMaterial) {
          console.log('No material select found');
          return;
        }
        
        const materialValue = selectedMaterial.value;
        console.log('Selected material:', materialValue);
        
        // Get all variants for the selected material
        const availableVariants = variantData.filter(variant => 
          variant.option1 === materialValue
        );
        
        // Get available style colours for this material
        const availableColours = availableVariants.map(v => v.option2);
        console.log('Available colours:', availableColours);
        
        // Update Style Colour dropdown options
        const colourSelect = this.form.querySelector('select[name="options[Style Colour]"]');
        if (colourSelect) {
          const options = colourSelect.querySelectorAll('option');
          options.forEach(option => {
            if (option.value === '') return; // Keep the placeholder option
            
            if (availableColours.includes(option.value)) {
              option.disabled = false;
              option.style.display = '';
            } else {
              option.disabled = true;
              option.style.display = 'none';
              console.log('Hiding:', option.value);
            }
          });
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
